import React from "react";
import Grid from "@material-ui/core/Grid";
import Layout from "Layout";
import {
  fromMonthly,
  toMonthly,
  fromDaily,
  toDaily,
  fromHourly,
  toHourly,
} from "fuction/date";
import { Typography } from "@material-ui/core";
import Tweet from "Components/Tweet";
import { makeStyles } from "@material-ui/core/styles";
import PosiTabs from "Components/PosiTabs";
import MyPagination from "Components/MyPagination";
import OrderSelect from "Components/OrderSelect";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import queryString from "query-string";
import useApi from "Hooks/useApi";
import useAuth from "Hooks/useAuth";
import useFilter from "Hooks/useFilter";
import "dayjs/locale/ja";
import dayjs from "dayjs";
import DatePickers from "Components/DatePickers";
import DateSinglePicker from "Components/DateSinglePicker";
import DateTimePicker from "Components/DateTimePicker";
import { animateScroll as scroll } from 'react-scroll';
import googleAnalytics from "fuction/googleAnalytics";
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@material-ui/core/Switch';
import Toolbar from '@material-ui/core/Toolbar';
import { useQueryString, modQueryPageNum, getQueryPageNum } from "Hooks/useQueryString";

dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(3),
    minWidth: 120,
  },
  sticky: {
    position: "-webkit-sticky", /* safari対応 */
    position: "sticky",
    top: 64,
    zIndex: 1,
    backgroundColor: "white",
    paddingLeft: 90,
    paddingRight: 90,
    width: "100%",
  },
}));

export default function KeywordDetail(props) {
  const { request, convertQueryParam } = useApi();
  const { word, date } = queryString.parse(props.location.search);
  const filter = useFilter();
  const auth = useAuth();
  const queryParams = useQueryString();
  const classes = useStyles();

  // 時間間隔を取得
  // 1h hourly / 1day daily / 1month monthly
  const interval = queryString.parse(props.location.search).interval;
  const activeGroup = auth.state.activeGroup;

  const [meta, setMeta] = React.useState({});
  const [graph, setGraph] = React.useState([]);
  const [retweetCount, setRetweetCount] = React.useState(0);
  const [page, setPage] = React.useState(getQueryPageNum(queryParams));
  const [totalCount, setTotalCount] = React.useState(0);
  const [order, setOrder] = React.useState("retweet");
  const [isHideImage, setIsHideImage] = React.useState(false);

  let fromDate = "";
  let toDate = "";
  if (interval && interval != "") {
    switch (interval) {
      case "monthly":
        fromDate = fromMonthly(filter.state.filteredDateFrom);
        toDate = toMonthly(filter.state.filteredDateTo);
        break;
      case "daily":
        fromDate = fromDaily(date);
        toDate = toDaily(date);
        break;
      case "hourly":
        fromDate = fromHourly(date);
        toDate = toHourly(date);
        break;
      default:
        break;
    }
  }

  const scrollToTop = () => {
    scroll.scrollToTop();
  }

  const handleChangeDateSingle = (date) => {
    props.history.push(`/keywords/details?activeGroup=${activeGroup}&word=${word}&date=${date}&interval=${interval}`);
  };

  const handleDateChange = (dateTime) => {
    props.history.push(`/keywords/details?activeGroup=${activeGroup}&word=${word}&date=${dateTime}&interval=${interval}`);
  };

  // キーワード情報を取得
  const rquestKeywords = () => {
    // 戻るボタンやURL直貼りで遷移してきたとき、queryParams と auth.state の activeGroup が食い違っていても、
    // 初回レンダでは state の activeGroup （デフォルトグループ）でリクエストして返されたデータで画面表示されてしまう。
    // Layout.js で queryParams と auth.state の activeGroup の同期をとったあとで走る再レンダ時のリクエストで
    // 後からデータを取得しても画面に反映されない（set○○(●●)までで再々レンダは走らない）ので、
    // 同期前で食い違いがあるうちはリクエストしない。
    const activeGroup = queryParams.get("activeGroup");
    if (activeGroup && auth.state.activeGroup !== parseInt(activeGroup, 10)) {
      return;
    }
    Promise.all([
      request({
        method: "GET",
        url: `data/:account_id/keywords/${
          auth.state.activeGroup
        }/statuses?${convertQueryParam({
          keyword: word,
          range: [fromDate, toDate],
          filter: {
            pn: filter.state.posiNegaTab,
          },
          order: order,
          pagination: {
            page: page,
            limit: 50,
          },
        })}`,
      }),
    ]).then(([graph]) => {
      setMeta(graph.meta);
      setGraph(graph.data);
      setTotalCount(graph.meta.total_count);
      setRetweetCount(graph.meta.rt_count);
      scrollToTop()
    });
  }

  // 初回レンダリングフラグ
  const isFirstRender = React.useRef(false);
  React.useEffect(() => {
    isFirstRender.current = true;
  }, []);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id);
  }, [props.location.pathname]);

  React.useEffect(() => {
    // 初回レンダー判定
    if(isFirstRender.current) { 
      // 初回レンダーではないように
      isFirstRender.current = false;
    } else {
      rquestKeywords();
    }
  }, [page]);

  const syncQueryPageNum = (...[pn]) => {
    if ((pn && pn === 1) || (totalCount > 0 && (Math.ceil(totalCount / 50)) < getQueryPageNum(queryParams))) {
      modQueryPageNum(queryParams, 1);
      props.history.push(props.location.pathname + "?" + queryParams.toString());
      setPage(1);
    }
    else {
      setPage(getQueryPageNum(queryParams));
    }
  }

  React.useEffect(() => {
    if (auth.state.activeGroup === 0) {
      return;
    }
    if (page === 1) {
      rquestKeywords();
    } else {
      syncQueryPageNum(1);
    }
  }, [auth.state.activeGroup, filter.state, order, filter.state.posiNegaTab, date]);

  const HeadDate = () => {
    if (interval === "monthly") {
      return (
        <DatePickers onChange={{}} />
      );
    }
    if (interval === "daily") {
      return (
        <DateSinglePicker
          date={fromDate}
          onChange={(date) => handleChangeDateSingle(date)}
        />
      );
    }
    if (interval === "hourly") {
      return (
        <DateTimePicker
          dateTime={fromDate}
          handleDateChange={handleDateChange}
          step={interval}
        />
      );
    }
  };

  if (page !== getQueryPageNum(queryParams)) {
    syncQueryPageNum();
  }
  return (
    <Layout
      content={
        <Grid container spacing={3}>
          <Toolbar className={classes.sticky}>
            <Grid item xs={12}>
              <Grid
                container
                direction="row"
                alignItems="flex-end"
                justifyContent="flex-start"
              >
                <HeadDate />
                <div className={classes.divider}></div>
                <PosiTabs />
                <div className={classes.divider}></div>
                <OrderSelect
                  handleChangeOrderSelect={(value) => {
                    setOrder(value);
                  }}
                  value={order}
                  isRetweet={true}
                />
                <div className={classes.divider}></div>
                <FormControl component="fieldset" className={classes.formControl}>
                  <FormGroup>
                    <FormControlLabel
                      control={<Switch size="small" checked={isHideImage} onChange={(event) => setIsHideImage(event.target.checked)} name="isHideImage" />}
                      label="画像を表示しない"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid container spacing={3} className={classes.formControl} justifyContent="center">
                <MyPagination
                count={Math.ceil(totalCount / 50)}
                currentPage={page}
                handlePagination={(page) => setPage(page)}
                />
              </Grid>
            </Grid>
          </Toolbar>
          <Grid container>
            <Typography>{meta.keyword}：</Typography>
            <Typography>{meta.total_count}件</Typography>
          </Grid>
          <Grid item xs={12}>
            {graph.map((row, index) => (
              <Tweet row={row} key={index} isHideImage={isHideImage} order={order} retweetCount={retweetCount[index]} />
            ))}
          </Grid>
        </Grid>
      }
    />
  );
}
